export const CascadeAction = Object.freeze({
    APPROVE: 'approve',
    REJECT: 'reject',
    GONEXT: 'goNext',
});

export const CascadeName = Object.freeze({
    DELETE_CASCADE: 'DeleteCascadeModal',
    DELETE_WITH_ORDER_CASCADE: 'DeleteWithActiveOrderCascadeModal',
    HIDE_CASCADE: 'HideCascadeModal',
    DEAL_COMPLETED_CASCADE: 'DealCompletedModal',
});